<template>
    <div class="result-area longer">
      <p>Det finns förutsättningar för att du kan ha en psykologisk orsak till dina besvär. Nedstämdhet och stress kan både minska lust och förmågan att få tillräcklig erektion. Psykologiska orsaker är vanligt hos yngre, där stress och osäkerhet inför att ha sex kan bidra till besvären.</p>
      
      <p v-if="hasAdditionalInfo_alt1">Enligt dina svar kan besvären även delvis bero på:
      
        <VueFaqAccordion 
          :items="getItems()"
          borderColor="transparent"
          fontColor="#2c3e50"
          activeColor="#2c3e50"
        />
        
      </p>      

      <p>Vid <span v-if="hasAdditionalInfo_alt1">ovanstående orsaker kan läkemedlet Sildenafil ha god effekt.</span><span v-else>psykologisk orsak är det viktigt att gå till botten med problemet, men läkemedlet Sildenafil kan också ha god effekt.</span></p>
    </div>
</template>

<script>
import VueFaqAccordion from 'vue-faq-accordion'
import { INDICATOR } from '../../../config/indicators'

export default { 
  inject: ["formState"],
  components: {
    VueFaqAccordion
  },
  data() {
    return {
      additionalInfoOHorm: "Hormonet testosteron är viktigt för att kunna få och bibehålla erektion. Då misstanken uppkommit rekommenderas du att ta kontakt med din vårdcentral för en bredare diskussion kring dina symtom och om eventuell utredning bör göras."
    }
  },
  computed: {
    hasAdditionalInfo_alt1() {
      return this.formState.additionalInfo_alt1.length ? true : false
    },
    additionalInfoTrigger_alt1() {
      switch (this.formState.additionalInfo_alt1) {
        case (INDICATOR.O_HORM): {
          return "Hormonrelaterad orsak"
        }
        default: {
          return ""
        }
      }
    },
    additionalInfoTxt_alt1() {
      switch (this.formState.additionalInfo_alt1) {
        case (INDICATOR.O_HORM): {
          return this.additionalInfoOHorm
        }
        default: {
          return ""
        }
      }
    },
  },
  methods: {
      getItems() {

      let extraItems = [];

      if (this.hasAdditionalInfo_alt1) {
        let item_1 = {
          title: this.additionalInfoTrigger_alt1,
          value: this.additionalInfoTxt_alt1
        }

        extraItems.push(item_1)
      }

      return extraItems
      
    }
  }
}
</script>
